export default "__VITE_ASSET__A38rZoqr__"